<script>
import { Bar, mixins  } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'ViewsChart',
  extends: Bar,
  mixins: [reactiveProp],
  data: function() {
    return {
      options:{
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            xAxes: [{
                type: 'time',
                time: {
                  displayFormats:{
                    hour: 'DD/MM - H:mm',
                  },
                },
                distribution: 'series',
                stacked: true
            }],
            yAxes: [{
                stacked: true,
                ticks: {
                  min:0
                }
            }]
        },
        plugins: {
          datalabels: false,
          labels: false
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>
</style>